import * as type from '../../constants';

const initialState = {
    qmsDashboardData: [],
    loading: false,
    downloadLoader: false,
    error: null,
}

export function qmsDashboard(state = initialState, action) {
    switch (action.type) {
        case type.GET_QMS_DASHBOARD_DATA:
            if(action.data?.downloadExcel)
                return {
                    ...state,
                    downloadLoader: true,
                }
            return {
                ...state,
                loading: true,
            }
        case type.GET_QMS_DASHBOARD_DATA_SUCCESS:
            if(action.payload?.downloadExcel)
                return {
                    ...state,
                    downloadLoader: false,

                }
            return {
                ...state,
                qmsDashboardData: action.qmsDashboardDataRes,
                loading: false,
                error: null
            }
        case type.GET_QMS_DASHBOARD_DATA_FAILURE:
            if(action.payload?.downloadExcel)
                return {
                    ...state,
                    downloadLoader: false,
                }
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}